import { gql } from "@apollo/client";

const FIND_NOTIFICATIONS = gql`
  query FindNotifications($args: UpdateNotificationInput) {
    findNotifications(args: $args) {
      _id
      audience
      createdAt
      createdBy {
        _id
        firstName
        lastName
        email
      }
      endDate
      notificationType
      title
      message
      productId
      severity
      startDate
      targetRoles
      exclusions {
        firmIds
        partnerIds
      }
      updatedAt
      updatedBy
      userId
      meta {
        isDeleted
        testData
      }
    }
  }
`;

const FIND_NOTIFICATIONS_SERVER_SIDE = gql`
  query FindNotificationsServerSide($input: ServerQueryInput) {
    findNotificationsServerSide(input: $input) {
      pageInfo {
        currentPage
        pageSize
        totalDocuments
        totalPages
      }
      notifications {
        _id
        audience
        createdAt
        createdBy {
          _id
          firstName
          lastName
          email
        }
        endDate
        notificationType
        title
        message
        productId
        severity
        startDate
        targetRoles
        exclusions {
          firmIds
          partnerIds
        }
        updatedAt
        updatedBy
        userId
        meta {
          isDeleted
          testData
        }
      }
    }
  }
`;

const FIND_ACTIVE_USER_NOTIFICATIONS = gql`
  query FindActiveUserNotifications($args: UpdateNotificationInput, $asUserId: ID) {
    findActiveUserNotifications(args: $args, asUserId: $asUserId) {
      _id
      audience
      createdAt
      createdBy {
        _id
        firstName
        lastName
        email
      }
      endDate
      hasRead
      message
      meta {
        isDeleted
        testData
      }
      productId
      severity
      startDate
      targetRoles
      exclusions {
        firmIds
        partnerIds
      }
      notificationType
      title
      updatedAt
      updatedBy
      userId
    }
  }
`;

const MY_NOTIFICATIONS = gql`
  query MyNotifications($includeArchived: Boolean, $archivedOnly: Boolean) {
    myNotifications(includeArchived: $includeArchived, archivedOnly: $archivedOnly) {
      _id
      audience
      title
      message
      createdAt
      createdBy {
        _id
        firstName
        lastName
        email
      }

      # audience: "user"
      userId
      eventType
      linkedReference {
        collection
        documentId
        boardId
      }
      isRead
      readAt
      isArchived
      archivedAt

      # audience: "roles"
      hasRead
      notificationType
      severity
      startDate
      endDate
      targetRoles
    }
  }
`;

const MY_UNREAD_COUNT = gql`
  query MyUnreadCount {
    myUnreadCount
  }
`;

export {
  FIND_NOTIFICATIONS,
  FIND_NOTIFICATIONS_SERVER_SIDE,
  FIND_ACTIVE_USER_NOTIFICATIONS,
  MY_NOTIFICATIONS,
  MY_UNREAD_COUNT,
};
